/**
 * Тур по странице отчётов.
 * Знакомит пользователя с генерацией и настройкой отчётов.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'reports-page',
  name: 'help.tours.reports.name',
  description: 'help.tours.reports.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие - тулбар
    {
      element: '.reports-toolbar',
      titleKey: 'help.tours.reports.welcome.title',
      descriptionKey: 'help.tours.reports.welcome.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 2: Панель настройки отчёта
    {
      element: '.side-panel--left',
      titleKey: 'help.tours.reports.panel.title',
      descriptionKey: 'help.tours.reports.panel.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 3: Пользовательские отчёты
    {
      element: '.report-panel__body',
      titleKey: 'help.tours.reports.customReports.title',
      descriptionKey: 'help.tours.reports.customReports.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 4: Типы отчётов
    {
      element: '.report-type-select-row',
      titleKey: 'help.tours.reports.reportTypes.title',
      descriptionKey: 'help.tours.reports.reportTypes.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 5: Табы (отчёт / расписания)
    {
      element: '.panel-tabs',
      titleKey: 'help.tours.reports.tabs.title',
      descriptionKey: 'help.tours.reports.tabs.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 6: Кнопки генерации
    {
      element: '.reports-toolbar__right',
      titleKey: 'help.tours.reports.actions.title',
      descriptionKey: 'help.tours.reports.actions.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 7: Область просмотра (если есть отчёт)
    {
      element: '.report-viewer, .reports-empty',
      titleKey: 'help.tours.reports.viewer.title',
      descriptionKey: 'help.tours.reports.viewer.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 8: Кнопка настройки колонок
    {
      element: '.report-type-settings-btn',
      titleKey: 'help.tours.reports.settingsButton.title',
      descriptionKey: 'help.tours.reports.settingsButton.description',
      side: 'left',
      align: 'center',
      expandSelector: '.report-type-settings-btn', // Автоматически раскрывает селектор
    },
    // Шаг 9: Селектор колонок
    {
      element: '.column-panel',
      titleKey: 'help.tours.reports.columnSelector.title',
      descriptionKey: 'help.tours.reports.columnSelector.description',
      side: 'right',
      align: 'start',
    },
    // Шаг 10: Действия с колонками
    {
      element: '.column-panel__actions',
      titleKey: 'help.tours.reports.columnActions.title',
      descriptionKey: 'help.tours.reports.columnActions.description',
      side: 'right',
      align: 'end',
    },
  ],
}
